import { getTestDrive } from '~~/src/server/modules/car'
import type { TestDriveResponse } from '~~/src/server/modules/car/types'
export function LogicTestDrive() {
  const testDriveInfo = ref<TestDriveResponse | null>(null)

  async function serverHandler(id: string) {
    const asyncData = await useAsyncData(`TEST_DRIVE_${id}`, () => getTestDrive(id))
    if (!asyncData)
      return
    const { data } = useNuxtAsyncHandle(asyncData, true)
    testDriveInfo.value = data || null
  }

  return {
    testDriveInfo,
    serverHandler,
  }
}
